// extracted by mini-css-extract-plugin
module.exports = {"pie__chart__wrapper":"Analytics_pie__chart__wrapper__CST6n","custom__tooltip":"Analytics_custom__tooltip__3N2J-"};